module.exports = __webpack_public_path__ + "img/dialog-bg.742e70e7.png";